/**
 * @generated SignedSource<<404f0b5d3517c2e23b724420922210ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type salesOrderAmountInlineFragment$data = {
  readonly subAmount: number;
  readonly taxAmount: number;
  readonly totalAmount: number;
  readonly discountAmount: number;
  readonly grandAmount: number;
  readonly currencyCode: string;
  readonly paymentTerms: any | null;
  readonly " $fragmentType": "salesOrderAmountInlineFragment";
};
export type salesOrderAmountInlineFragment$key = {
  readonly " $data"?: salesOrderAmountInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"salesOrderAmountInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "salesOrderAmountInlineFragment"
};

(node as any).hash = "abadbda0b934d246eb44ac3e5e3c8dda";

export default node;
